import { Link } from "react-router-dom";
import SEO from "@/components/SEO";

const policies = [
  {
    title: "Cancellation Policy",
    body: [
      "We ask for a minimum of 48 hours' notice for any cancellation or rescheduling.",
      "Cancellations made within 48 hours of your appointment will forfeit the booking deposit.",
      "This policy allows us to offer the time to another client on our waiting list."
    ]
  },
  {
    title: "Late Policy",
    body: [
      "We hold appointments for a 10-minute grace period.",
      "Arrivals beyond this window may require rescheduling and forfeiture of the deposit, as we cannot compress a medical treatment safely.",
      "If you anticipate delay, please contact us as early as possible — we will do our best to accommodate."
    ]
  },
  {
    title: "Consultation Policy",
    body: [
      "All new clients begin with a private consultation with Natalia.",
      "A modest consultation fee applies and is credited toward your first treatment if booked within 30 days.",
      "Consultations are unhurried, private, and designed to build a plan — not to sell."
    ]
  },
  {
    title: "Deposit Policy",
    body: [
      "A refundable deposit is required to secure all bookings.",
      "The deposit is applied to your treatment total on the day of service.",
      "Deposits are refundable when a cancellation is made in accordance with our cancellation policy."
    ]
  },
  {
    title: "Privacy Policy",
    body: [
      "Your medical information is protected and never shared without your explicit consent.",
      "Any imagery captured for medical records or portfolio purposes is only used with a signed release.",
      "You have the right to access, correct, or request deletion of your personal data at any time."
    ]
  }
];

export default function Policies() {
  return (
    <div data-testid="policies-page" className="pt-32 md:pt-40 bg-[#FAF8F5]">
      <SEO
        title="Policies | Natalia Medical Aesthetics in Kirkland, WA"
        description="Cancellation, late, consultation, deposit and privacy policies for Natalia Medical Aesthetics in Kirkland, WA."
        path="/policies"
      />
      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="max-w-3xl">
          <div className="overline mb-6">Policies</div>
          <h1 className="font-serif text-5xl md:text-6xl lg:text-[5.2rem] leading-[1.02] tracking-tight">
            Clear, honest <em className="italic text-[#8A847C]">expectations.</em>
          </h1>
          <p className="mt-10 text-[1.05rem] text-[#5C5C5C] leading-relaxed max-w-2xl">
            The following policies exist to protect your care, your time, and ours.
            They ensure every client is met with the same attention and space they deserve.
          </p>
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 py-20 md:py-28">
        <div className="space-y-16 md:space-y-24">
          {policies.map((p, i) => (
            <div key={p.title} data-testid={`policy-${i}`} className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-14 pb-16 md:pb-20 border-b border-[#E5E0DA] last:border-b-0">
              <div className="lg:col-span-4">
                <div className="overline mb-4">§ {String(i + 1).padStart(2, "0")}</div>
                <h2 className="font-serif text-3xl md:text-4xl lg:text-5xl leading-tight tracking-tight">{p.title}</h2>
              </div>
              <div className="lg:col-span-8 space-y-5 max-w-2xl">
                {p.body.map((b, bi) => (
                  <p key={bi} className="text-[#1A1A1A] text-base md:text-lg leading-relaxed">{b}</p>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-[1600px] mx-auto px-6 md:px-10 lg:px-16 pb-24 md:pb-32">
        <div className="bg-[#1A1A1A] text-white rounded-[28px] p-12 md:p-24 text-center">
          <h3 className="font-serif text-4xl md:text-6xl leading-[1.05] tracking-tight max-w-3xl mx-auto">
            Any questions <em className="italic">on our policies?</em>
          </h3>
          <div className="mt-12">
            <Link to="/book" data-testid="policies-cta-btn" className="inline-flex items-center bg-white text-[#1A1A1A] rounded-full px-10 py-5 text-[0.85rem] font-medium font-medium hover:bg-[#F3EFEA] transition-colors">
              Contact Us
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
